<template>
    <div 
        id="tabs-header" 
        class="py-2 d-flex" 
        :class="[$vuetify.breakpoint.xsOnly ?' px-2' : 'px-4']"
        v-if="data"
    >
        <div 
            v-if="backButton" 
            class="d-flex justify-start pr-2"
        >
            <v-btn 
                @click.prevent="goBack()"
                icon 
            >
                <v-icon>
                    icon-return
                </v-icon>
            </v-btn>
        </div>
        <div 
            v-if="data.activeHotspot" 
            class="pr-2 mb-2"
        >
            <v-img
                :class="{ 'ml-3': $vuetify.breakpoint.smAndUp && $vuetify.breakpoint.width > 750 }"
                :src="hotspotImg"
                max-width="35"
                contain
            />
        </div>
        <div class="justify-start text-truncate mb-1 pl-4">
            <v-toolbar-title>
                <h3 class="font-weight-black">
                    {{ title }}
                </h3>
            </v-toolbar-title>
            
            <span
                v-if="subtitle"
                class="habiteo-body-2"
            >
                {{ subtitle }}
            </span>
        </div>
        <v-spacer></v-spacer>
        <div 
            v-if="['program', 'general'].includes(data.type) || data.widgetType === 'general'" 
            class="justify-end"
        >
            <v-btn
                v-if="programInfo"
                icon 
                @click.prevent="toogleProgrammeInfoPopup()"
                width="100%"
            >
                <v-icon>
                    mdi-information-outline
                </v-icon>
            </v-btn>
            
            <ProgramInfo
                v-if="programInfo"
                :dialog="dialog"
                @close_program_info_dialog="toogleProgrammeInfoPopup()"
            />
        </div>
        <CutawayHeader
            v-else-if="data.type === 'cutaway' || data.type === 'plot-grid'"
            :data="data"
        />
        <PlotHeader
            v-else-if="data.type === 'plot'"
            :data="data"
            :isStandalone="isStandalone"
        />
        <ConfigurableTourHeader
            v-else-if="data.type === 'configurable-tour'"
            :data="data"
        />
        <MapHeader
            v-else-if="data.type === 'map'"
            :data="data"
            @toggle-search-route="toggleSearchRoute()"
        />
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import PlotHeader from "@/layout/alternative/plot/PlotHeader";
    import ConfigurableTourHeader from "@/layout/alternative/configurableTour/ConfigurableTourHeader";
    import MapHeader from "@/layout/alternative/map/MapHeader";
    import ProgramInfo from "@/layout/alternative/program/components/ProgramInfo";
    import CutawayHeader from "@/layout/alternative/cutaway/CutawayHeader";

    export default {
        name: "HeaderLayout",
        components: {
            ProgramInfo,
            CutawayHeader,
            PlotHeader,
            ConfigurableTourHeader,
            MapHeader
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            backButton: {
                type: Boolean,
                default: false
            },
            goBack: {
                type: Function,
                default: null
            },
            activeWidget: {
                type: Object,
                required: false
            },
            isStandalone: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            dialog: false,
            hotspotImg: require('@/assets/images/sidebar-color-pin.png'),
        }),
        computed: {
            ...mapGetters([
                "programInfo"
            ]),
            ...mapGetters("widget", [
                "displayFavorite",
                "showPlotCount"
            ]),
            resultText() {
                return this.plotCounter > 0 ? this.$t("cutawayHeader.searchResult.moreThanOne") : this.$t("cutawayHeader.searchResult.oneResult");
            },
            plotCounter() {
                return this.$props.data.floors ? this.unicPlotList().length : 0;
            },
            title() {
                switch (this.$props.data.type) {
                    case 'models':
                        return this.$props.data.activeHotspot && this.$props.data.activeHotspot.type === "virtual-tour" ? this.$props.data.activeHotspot.name : this.widgetTitle;
                    case 'documentation' :
                    case 'plot-grid':
                    case 'map':
                    case 'configurable-tour':
                        return this.widgetTitle;

                    case 'program':
                    case 'general':
                        if(this.$props.data.activeHotspot)
                            return this.$props.data.activeHotspot.name;
                        if (this.activeWidget)
                            return this.activeWidget.text || this.activeWidget.name;
                        else
                            return this.widgetTitle; 
                    case 'plot':
                        return this.$props.data.title;

                    default:
                        return this.widgetTitle; 
                }
            },
            widgetTitle() {
                return this.$props.data.widgetTitle ? this.$props.data.widgetTitle[0].toUpperCase() + this.$props.data.widgetTitle.slice(1) : null;
            },
            subtitle() {
                if(this.$props.data.widgetType === 'general')
                    return this.$props.data.program.fullAddress;

                switch (this.$props.data.type) {
                    case 'program':
                    case 'general':
                        return this.$props.data.program.fullAddress;
                    case 'cutaway':	
                    case 'plot-grid':
                        if (this.showPlotCount)
                            return `${this.plotCounter} ${this.resultText} ${this.$t('cutawayHeader.searchResult.onThisFloor')}`; 
                    case 'configurable-tour':
                        if(this.$props.data.configurationOptions)
                            return `${this.$props.data.configurationOptions.length} ${this.$t('alternative.partsWitnesses')}`;
                    default:
                        return null;
                }
            },
        },
        methods: {
            getHotspotList() {
                let hotspotsList = [];
                let currentFloor = this.$props.data.floors.findIndex(floor => floor.active);
                if (this.$props.data.floors)
                    hotspotsList = this.$props.data.floors[currentFloor].hotspots.filter(
                        el => el.visible
                    );
                return hotspotsList;
            },
            unicPlotList() {
                let plotList = [];
                let nameList = [];
                this.getHotspotList().filter(el => el.visible).forEach(plot => {
                    if (!nameList.includes(plot.name)) {
                        plotList.push(plot);
                        nameList.push(plot.name);
                    }
                });
                if (plotList.length > 0)
                    this.userChoiceClosedSearchPopup = false;
                return plotList;
            },
            toogleProgrammeInfoPopup(){
                this.dialog = !this.dialog;
            },
            toggleSearchRoute(){
                this.$emit('toggle-search-route');
            } 
        },
    };
</script>



// WEBPACK FOOTER //
// src/layout/alternative/layout/HeaderLayout.vue